var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5V10.5M2 10.5H7M2 10.5C2 11.75 3.25 13 7 13M7 10.5H12M7 10.5V0.5M12 10.5V0.5M12 10.5C12 11.75 10.75 13 7 13M7 13V25.5M22 25.5V14.25M22 14.25V1.75C21.2678 1.75 20.6428 1.96447 20.125 2.29917M22 14.25H20.125M20.125 14.25H18.25V5.5C18.25 4.61612 18.875 3.10723 20.125 2.29917M20.125 14.25V2.29917",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.8fdd08478416625b1352ffcca136016e.svg";
export { ForwardRef as ReactComponent };